// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  height: var(--height-header);
  align-items: center;
  position: relative;
  z-index: 1;
  gap: 15px;
}

#Header-module-accountButton {
  background-color: transparent;
  box-shadow: none;
  padding: 0;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-weight: 200;
  flex-shrink: 0;
}

#Header-module-avatarContainer {
  height: 30px;
  width: 30px;
  background-color: gray;
  display: flex;
  flex-shrink: 0;
  border-radius: 100%;
}

#Header-module-left {
  display: flex;
  align-items: center;
  gap: 15px;
  height: 100%;
}

#Header-module-left > section {
  height: 100%;
}

#Header-module-left a {
  font-size: 17px;
  font-weight: 400;
  color: black;
  text-decoration: none;
}

.Header-module-mobileSearching > #Header-module-left, .Header-module-mobileSearching #Header-module-accountButton, #Header-module-nameContainer {
  display: none;
}

.Header-module-mobileSearching > #Header-module-right, .Header-module-mobileSearching > #Header-module-right > section, .Header-module-mobileSearching > #Header-module-right > section > section {
  flex-grow: 1;
}

#Header-module-right {
  display: flex;
  gap: 15px;
  height: 100%;
}

#Header-module-right > section {
  display: flex;
}

#Header-module-right > section > section {
  display: flex;
}

#Header-module-projectSelector {
  background-color: var(--background);
  color: var(--text);
  border: 1px solid var(--border);
  padding: 5px 15px;
  cursor: initial;
}

@media screen and (min-width: 400px) {

  .Header-module-selected {
    background-color: var(--link-selected);
    font-weight: 400;
  }

}

@media screen and (min-width: 720px) {
  
  #Header-module-accountButton {
    border-radius: 5px;
  }

  #Header-module-nameContainer {
    display: flex;
    color: var(--text);
  }

  .Header-module-mobileSearching > #Header-module-left, .Header-module-mobileSearching #Header-module-accountButton {
    display: flex;
  }

  #Header-module-right {
    justify-content: space-between;
    flex-grow: 1;
  }

  #Header-module-right > section, #Header-module-right > section > section {
    flex-grow: 1;
    justify-content: right;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE;IACE,sCAAsC;IACtC,gBAAgB;EAClB;;AAEF;;AAEA;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;AAEF","sourcesContent":["header {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n  height: var(--height-header);\n  align-items: center;\n  position: relative;\n  z-index: 1;\n  gap: 15px;\n}\n\n#accountButton {\n  background-color: transparent;\n  box-shadow: none;\n  padding: 0;\n  border-radius: 100%;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  font-weight: 200;\n  flex-shrink: 0;\n}\n\n#avatarContainer {\n  height: 30px;\n  width: 30px;\n  background-color: gray;\n  display: flex;\n  flex-shrink: 0;\n  border-radius: 100%;\n}\n\n#left {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  height: 100%;\n}\n\n#left > section {\n  height: 100%;\n}\n\n#left a {\n  font-size: 17px;\n  font-weight: 400;\n  color: black;\n  text-decoration: none;\n}\n\n.mobileSearching > #left, .mobileSearching #accountButton, #nameContainer {\n  display: none;\n}\n\n.mobileSearching > #right, .mobileSearching > #right > section, .mobileSearching > #right > section > section {\n  flex-grow: 1;\n}\n\n#right {\n  display: flex;\n  gap: 15px;\n  height: 100%;\n}\n\n#right > section {\n  display: flex;\n}\n\n#right > section > section {\n  display: flex;\n}\n\n#projectSelector {\n  background-color: var(--background);\n  color: var(--text);\n  border: 1px solid var(--border);\n  padding: 5px 15px;\n  cursor: initial;\n}\n\n@media screen and (min-width: 400px) {\n\n  .selected {\n    background-color: var(--link-selected);\n    font-weight: 400;\n  }\n\n}\n\n@media screen and (min-width: 720px) {\n  \n  #accountButton {\n    border-radius: 5px;\n  }\n\n  #nameContainer {\n    display: flex;\n    color: var(--text);\n  }\n\n  .mobileSearching > #left, .mobileSearching #accountButton {\n    display: flex;\n  }\n\n  #right {\n    justify-content: space-between;\n    flex-grow: 1;\n  }\n\n  #right > section, #right > section > section {\n    flex-grow: 1;\n    justify-content: right;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accountButton": `Header-module-accountButton`,
	"avatarContainer": `Header-module-avatarContainer`,
	"left": `Header-module-left`,
	"mobileSearching": `Header-module-mobileSearching`,
	"nameContainer": `Header-module-nameContainer`,
	"right": `Header-module-right`,
	"projectSelector": `Header-module-projectSelector`,
	"selected": `Header-module-selected`
};
export default ___CSS_LOADER_EXPORT___;
